module.exports = __webpack_public_path__ + "img/placeholder1.33cdeeac.png";